import { Component, OnDestroy } from "@angular/core";
import { FormControl, FormGroup, Validators } from "@angular/forms";
import { NotificationFacade } from "src/app/notifications/services/notification.facade";
import { TemplateFacade } from "src/app/services/template.facade";
import { SubSink } from "subsink";
import { ICirculationTemplate } from "../../interfaces";
import { LogClass } from "../../logger/log.classdecorater";
import { Logger } from "../../logger/logger";
import { NavigationService } from "../../services/navigation.service";

@Component({
    selector: "circ-new-template",
    templateUrl: "./new.component.html",
    styleUrls: ["./new.component.scss"],
    standalone: false
})
@LogClass({ source: "Template/NewComponent" })
export class NewComponent implements OnDestroy {
  public form = new FormGroup({
    circulationTitle: new FormControl("", [Validators.required]),
    title: new FormControl("", [Validators.required]),
    demand: new FormControl("", [Validators.required])
  });

  public saving = false;

  private logger: Logger;
  private subscriptions = new SubSink();

  constructor(
    private templateFacade: TemplateFacade,
    private navigate: NavigationService,
    private notification: NotificationFacade
  ) {
    this.logger.debug("ctor");
  }

  public abort(): void {
    this.navigate.toDashboard();
  }

  public ngOnDestroy(): void {
    this.subscriptions.unsubscribe();
  }

  public save(): void {
    this.form.markAllAsTouched();
    if (!this.form.valid) {
      return;
    }

    const circ: ICirculationTemplate = {
      circulationTitle: this.form.value.circulationTitle,
      duration: 1,
      id: 0,
      title: this.form.value.title,
      steps: [],
      payload: {
        demand: this.form.value.demand
      },
      permissions: {
        ownerId: 0
      }
    };

    this.saving = true;
    this.logger.info("saving");

    this.subscriptions.sink = this.templateFacade.save(circ).subscribe({
      next: (id) => {
        this.logger.info("saved:" + id);
        this.navigate.toTemplate(id);
      },
      error: (err) => {
        this.logger.info("error creating template");
        this.notification.showError(
          "Error while saving this template. Please ask your Administrator for help! " +
            err.error.message
        );
      }
    });
  }
}
